export default {
  common: {
    colon: '：',
    cancel: 'キャンセル',
    confirm: '確認',
    back: '戻る',
    noBooking: '予約情報が見つかりません',
    placeholderNote: '画面は準備中です（デザイン待ち）'
  },
  views: {
    trainList: {
      vehicleInfo: '車両情報',
      ticketName: '新幹線チケット',
      travelDate: '利用日：',
      route: '出発と到着：',
      ticketCount: '予約数：',
      adult: '大人',
      child: '子供',
      trainType: '車種',
      seatClass: '座席タイプ：',
      preOrderNote:
        '※1ヶ月以上先のご予約の場合、発券は乗車日の1ヶ月前になります。結果はホームでご確認いただけます',
      selectStation: '駅を選択',
      from: '出発',
      to: '到着',
      selectTrain: '列車を選択',
      select: '選択',
      book: '予約',
      seatAvailable: '空席あり',
      seatLimited: '残りわずか',
      soldOut: '満席',
      notOnSale: '発売前',
      durationFormat: '{{hours}}時間{{minutes}}分',
      noTrains: 'この時間帯に列車はありません'
    },
    seat: {
      title: '座席を選択',
      ticketCount: '予約数',
      adult: '大人',
      preference: '座席の希望',
      window: '窓側優先',
      aisle: '通路側優先',
      adjacent: '隣席優先',
      next: '次へ'
    },
    confirm: {
      trainConfirm: '列車の確認',
      ticketName: '新幹線チケット',
      route: '出発と到着：',
      travelDate: '利用日：',
      ticketCount: '予約数：',
      trainType: '車種：',
      seatClass: '座席タイプ：',
      preference: '座席の希望：',
      confirmSelect: '選択を確認'
    },
    submitted: {
      title: '予約を送信しました',
      thanks: 'ご予約ありがとうございます。ホームで発券結果をご確認ください',
      thanksSub: '※乗車1ヶ月前より発券を開始します。しばらくお待ちください',
      ticketName: '新幹線チケット',
      route: '出発と到着：',
      travelDate: '利用日：',
      ticketCount: '予約数：',
      trainType: '車種：',
      seatClass: '座席タイプ：',
      preference: '座席の希望：',
      backHome: 'ホームに戻る',
      noticeTitle: 'ご注意事項',
      notice1:
        '毎日23:30〜05:30（日本時間）のシステムメンテナンス中は発券を停止します。メンテナンス終了後に自動で発券され、結果はホームで確認できます。',
      notice2:
        '発券に失敗した場合、ホームのチケットに「残りわずか」と表示されます。下部の「チケットを予約」ボタンから再度お手続きください。'
    }
  }
};
